import React from "react";

import AddNewButton from "./addNewButton";
import OrgButton from "./orgButton";
//import PlaceholderButton from "./placeholderButton";
import UserButton from "./userButton";

export default (props) => (
	props.isAddNew ? <AddNewButton { ...props } /> :
	props.isOrg ? <OrgButton { ...props } /> :
	//props.isPlaceholder ? <PlaceholderButton { ...props } /> :
	props.isUser ? <UserButton { ...props } /> :
	null
);
